import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { landingStyles } from "components/Landing/landingStyles";
import HeroBanner from "components/Marketing/Components/HeroBanner";
import Footer from "components/Footer";
import FeatureGrid from "./FeatureGrid";
import { BUTTON_TAGS, STATUS, UI_THEME } from "utils/constants/ui";
import LogoConnection from "components/LogoConnection";
import { cellGrow } from "constants/styles";
import PATHS from "utils/paths";
import Link from "next/link";
import { isServer } from "utils/view";
import FeatureComparisonTable from "components/FeatureComparisonTable";
import { magicCheckoutStyles } from "components/Landing/MagicCheckout/magicCheckoutStyles";
import DATA from "./data";
import LeadEmailSection from "components/LeadEmailSection";
import { createUserLead } from "actions/user";
import {
  PRODUCT_FEATURE_CAPABILITY,
  CONTEXTS
} from "utils/constants/capability";
import { SECURE_ACTIONS, verifyRequest } from "utils/security";
import Button from "components/Form/fields/Button";

const MarketingAdvancedLinks = ({ actions }) => {
  const tryButtonProps = {
    tag: BUTTON_TAGS.LINK,
    href: PATHS.FEATURES_LINKS_BUILDER,
    copy: "Try demo",
    classes: {
      button:
        "fw6 br2 pa3 border-box input-reset ba bg-transparent pointer f4 dib link items-center flex flex-shrink-0 cell-grow"
    }
  };
  const heroProps = {
    header: [
      {
        copy: "The most"
      },
      {
        classes: "color-primary underline",
        copy: "advanced"
      },
      {
        copy: "Stripe payment links."
      }
    ],
    action: tryButtonProps,
    customClasses: {
      actions: "dib center pt3 flex flex-column items-center justify-center"
    },
    paddingBottom: 20,
    subheader:
      "Advanced functionality for your Stripe payment links, no coding required."
  };

  const createLead = ({ email }, cb) => {
    const { createUserLead } = actions;
    const lead = {
      email,
      preferences: {
        feature: PRODUCT_FEATURE_CAPABILITY.API_PAYMENT_LINKS,
        context: CONTEXTS.ALL
      }
    };

    verifyRequest({
      action: SECURE_ACTIONS.WAITLIST,
      onSuccess: () => {
        createUserLead({ lead }, cb);
      },
      onError: (err) => {
        cb(err);
      }
    });
  };

  return (
    <div className="w-100 relative">
      <div className="mw8 center">
        <HeroBanner {...heroProps} />
        <div className="pb3">
          <Link href={PATHS.FEATURES_LINKS_BUILDER}>
            <div className="pointer cell-grow">
              <LogoConnection src="/assets/priceblocs_advancedLinksConnect.png" />
            </div>
          </Link>
        </div>
        <div className="pa3 pb5 flex flex-row">
          <FeatureGrid />
        </div>
      </div>
      <div className="w-100 before__image magic_checkout_link_bg relative">
        <div className="w-100 relative mw8 center">
          <div className="w-100 flex items-center justify-center pt5 pt0-ns pb5">
            <div className="flex flex-column justify-center">
              <div className="fw6 tc dib bg-white center f3 f2-l pb2 ph3 ph0-l">
                Feature comparison
              </div>
              <div className="tc dib bg-white center f5 pb2 lh-copy ph3 ph0-l ph3">
                See how PriceBlocs enhances standard Stripe payment links
              </div>
            </div>
          </div>
          <FeatureComparisonTable {...DATA} />
        </div>
      </div>
      <div className="w-100 before__image magic_checkout_link_bg relative">
        <div className="w-100 relative mw8 center pt5 pv5-l">
          <div className="w-100 flex items-center justify-center">
            <div className="flex flex-column justify-center">
              <div className="fw6 tc dib bg-white center f3 f2-l pb2 ph3 ph0-l">
                Build a payment link
              </div>
              <div className="tc dib bg-white center f5 pb2 lh-copy ph3 ph0-l">
                Try building your own using our no code link editor
              </div>
            </div>
          </div>
          {!isServer() && (
            <div className="flex flex-column flex-row-ns items-center justify-center pt3">
              <div className="pb3 pb0-ns">
                <Button {...tryButtonProps} />
              </div>
            </div>
          )}
        </div>
        <div className="pt5">
          <LeadEmailSection
            header="Payment Link API"
            subheader="Want to access the power of payment links through a simple API? Enter your email to get added to the waitlist"
            pill={{
              copy: "Beta",
              status: STATUS.WARNING,
              theme: UI_THEME.SLIM,
              customClasses: {
                container: "dib"
              }
            }}
            action={{
              onClick: createLead,
              copy: "Join Beta"
            }}
          />
        </div>
        <div className="dib h3 h4-l"></div>
      </div>
      <div className="mw8 center">
        <div className="pt5 hairline-1 bt">
          <Footer />
        </div>
      </div>
      <style jsx>{landingStyles}</style>
      <style jsx>{magicCheckoutStyles}</style>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      createUserLead
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(MarketingAdvancedLinks);
